import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IGetContaReceberArquivoByIdUseCase } from "../../../presentation/useCases/read/get_conta_receber_arquivo_by_id_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContaReceberArquivoByIdUseCase
 */

export class GetContaReceberArquivoByIdUseCase implements IGetContaReceberArquivoByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(
    idContasReceber: number,
    nroArquivo: number,
    imageName: string,
  ): Promise<void> {
    const result = await this.repository.getContasReceberArquivoById(idContasReceber, nroArquivo);
    await downloadFromBlobUrl(result, imageName);
  }
}
